<template>
<v-container fluid fill-height>
    <cropWorkAbsenceList :cropWorkAttendanceMemberID="cropWorkAttendanceMemberID" :cropWorkAttendanceID="cropWorkAttendanceID" :editMode="editMode" />
</v-container>
</template>

<script>
import cropWorkAbsenceList from "@/components/plants/team/cropWorkAttendanceMemberAbsencesList.vue"

export default {
    components: {
        cropWorkAbsenceList: cropWorkAbsenceList
    },
    data() {
        return {
            loading: false,
            error: null,
            submitError: null,
            submitLoading: false,
        }
    },
    computed: {
        cropWorkAttendanceMemberID() {
            const array = this.$route.params.cropWorkAttendanceAndMemberID.split('-');
            return parseInt(array[0]);
        },
        cropWorkAttendanceID() {
            const array = this.$route.params.cropWorkAttendanceAndMemberID.split('-');
            return parseInt(array[1]);
        },
        editMode() {
            const array = this.$route.params.cropWorkAttendanceAndMemberID.split('-');
            return array[2] === "True" ? false : true;
        }
    },
    async created() {
        //empty
    }
}
</script>